export const InstantIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_24646_89134)">
      <path
        d="M6.71452 8.64046C5.79607 8.64046 4.87803 8.99007 4.17879 9.68891C2.78112 11.087 2.78112 13.3619 4.17879 14.76C5.57686 16.158 7.85218 16.1576 9.25025 14.76C10.6479 13.3619 10.6479 11.087 9.25025 9.68891C8.55142 8.99007 7.63257 8.64046 6.71452 8.64046Z"
        fill="white"
      />
      <path
        d="M19.4149 0.0464027L13.0465 3.39058L13.1225 2.56653C13.1345 2.42253 13.0705 2.28252 12.9505 2.19852C12.8305 2.11851 12.6785 2.10651 12.5465 2.17051L3.81805 6.42674C1.92995 7.35079 0.549878 9.13488 0.133856 11.199C-0.270165 13.1991 0.249862 15.2072 1.56593 16.7113C1.66594 16.8273 1.77394 16.9433 1.88595 17.0553C2.966 18.1354 4.34208 18.8074 5.85816 18.9994C6.11017 19.0274 6.36218 19.0434 6.61419 19.0434C8.94632 19.0434 11.1984 17.7113 12.3865 15.5592L16.2387 8.57885C16.3067 8.45884 16.3027 8.30684 16.2347 8.18683C16.1627 8.06682 16.0347 7.99082 15.8947 7.98682L14.3026 7.95882L19.9189 0.646434C20.0309 0.494426 20.0269 0.286415 19.9069 0.142408C19.7869 -0.00159988 19.5829 -0.0416019 19.4149 0.0464027ZM9.81596 15.3256C8.96072 16.1804 7.83786 16.6081 6.7146 16.6081C5.59134 16.6081 4.46848 16.1804 3.61324 15.3256C1.90355 13.6155 1.90355 10.8334 3.61324 9.12328C5.32373 7.41319 8.10587 7.41319 9.81596 9.12328C11.5257 10.8334 11.5257 13.6155 9.81596 15.3256Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_24646_89134">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
